import React, { createContext, useContext, useState, useCallback } from "react";

const AICtx = createContext(null);

export function AIProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState("");
  const [context, setContext] = useState("");

  const openDrawer = useCallback((opts = {}) => {
    if (opts.prefill !== undefined) setPrefill(opts.prefill);
    if (opts.context !== undefined) setContext(opts.context);
    setOpen(true);
  }, []);

  const closeDrawer = useCallback(() => setOpen(false), []);

  const clearPrefill = useCallback(() => setPrefill(""), []);

  return (
    <AICtx.Provider value={{ open, openDrawer, closeDrawer, prefill, clearPrefill, context, setContext }}>
      {children}
    </AICtx.Provider>
  );
}

export function useAI() { return useContext(AICtx); }
